import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";
import DashboardLayout from "../../../examples/LayoutContainers/DashboardLayout";
import { ShimmerPostList } from "react-shimmer-effects";
import { deleteDestination, getDestination } from "../../../actions/destination/destination";
import DestinationListComponent from "../../../components/Definition/Destination/DestinationListComponent";

export default function DestinationScreen() {
    const [destination, setDestination] = useState({ data: [], links: {} });
    const [loading, setLoading] = useState(true);
    const [status, setStatusDelete] = useState(false);
    const [searchParams, setSearchParams] = useSearchParams();

    useEffect(() => {
        setLoading(true);
        const fetchApi = async () => {
            const params = new URLSearchParams(searchParams);
            try {
                const usersData = await getDestination(params.toString());
                setLoading(false);
                setDestination(usersData.status !== "error" ? usersData.message : { data: [], links: {} });
            } catch (error) {
                toast.error('خطا در اتصال به سرور!');
                setLoading(false);
            }
        };

        fetchApi();
    }, [searchParams,status]);

    return (
        <DashboardLayout>
            {loading ? <ShimmerPostList postStyle="STYLE_THREE" col={1} row={3} gap={30} /> : <DestinationListComponent lists={destination} deleteInvoke={async(id)=>{
                const prompt = window.confirm("آیا میخواهید مقصد حذف شود ؟ با این کار گزارشات وابسته از بین خواهد رفت")
                if(prompt){
                    const response = await deleteDestination(id);
                    if (response.status === "success") {
                        toast.success("مقصد حذف شد!");
                        setStatusDelete(true);
                    } else {
                        toast.error("خطا در حذف مقصد");
                    }
                }
            }} />}
        </DashboardLayout>
    );
}
